import React from 'react'

import Widget from '../Widget'
import HorizontalBarChart from '../components/HorizontalBarChart'
import Subtitle from '../../../components/Subtitle'
import Box from '../../../components/Box'
import withFetch from '../../../infrastructure/withFetch'

const buildQuery = (eventId, startDate, endDate) =>
    `/api/impressions/get-homepage-impressions-by-section-title/${eventId}?startDate=${startDate}&endDate=${endDate}`

const Chart = withFetch(
    props => buildQuery(props.eventId, props.startDate, props.endDate),
    ({ status, data, retry }) => (
        <Widget status={status} data={data} retry={retry}>
            <HorizontalBarChart
                data={data.map(d => ({
                    x: d.interactionTarget,
                    y: d.totalImpressions,
                }))}
            />
        </Widget>
    ),
)

const tooltip = (
    <div>
        <p>Total impressions per section</p>
    </div>
)

const GetImpressionsBySectionsWidget = ({ eventId, startDate, endDate }) => (
    <div>
        <Subtitle
            title="Total impressions per section"
            tooltip={tooltip}
        />
        <Box>
            <Chart startDate={startDate} endDate={endDate} eventId={eventId} />
        </Box>
    </div>
)

export default GetImpressionsBySectionsWidget
